function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import _extends from "@babel/runtime/helpers/esm/extends";
import resolveProps from '@mui/utils/resolveProps';
import { DEFAULT_GRID_COL_TYPE_KEY, GRID_STRING_COL_DEF, getGridDefaultColumnTypes } from "../../../colDef/index.js";
import { gridColumnsStateSelector, gridColumnVisibilityModelSelector } from "./gridColumnsSelector.js";
import { clamp } from "../../../utils/utils.js";
import { gridDensityFactorSelector } from "../density/densitySelector.js";
import { gridHeaderFilteringEnabledSelector } from "../headerFiltering/gridHeaderFilteringSelectors.js";
import { gridColumnGroupsHeaderMaxDepthSelector } from "../columnGrouping/gridColumnGroupsSelector.js";
export var COLUMNS_DIMENSION_PROPERTIES = [
    'maxWidth',
    'minWidth',
    'width',
    'flex'
];
var COLUMN_TYPES = getGridDefaultColumnTypes();
/**
 * Computes width for flex columns.
 * Based on CSS Flexbox specification:
 * https://drafts.csswg.org/css-flexbox-1/#resolve-flexible-lengths
 */ export function computeFlexColumnsWidth(param) {
    var initialFreeSpace = param.initialFreeSpace, totalFlexUnits = param.totalFlexUnits, flexColumns = param.flexColumns;
    var uniqueFlexColumns = new Set(flexColumns.map(function(col) {
        return col.field;
    }));
    var flexColumnsLookup = {
        all: {},
        frozenFields: [],
        freeze: function(field) {
            var value = flexColumnsLookup.all[field];
            if (value && value.frozen !== true) {
                flexColumnsLookup.all[field].frozen = true;
                flexColumnsLookup.frozenFields.push(field);
            }
        }
    };
    // Step 5 of https://drafts.csswg.org/css-flexbox-1/#resolve-flexible-lengths
    function loopOverFlexItems() {
        // 5a: If all the flex items on the line are frozen, free space has been distributed.
        if (flexColumnsLookup.frozenFields.length === uniqueFlexColumns.size) {
            return;
        }
        var violationsLookup = {
            min: {},
            max: {}
        };
        var remainingFreeSpace = initialFreeSpace;
        var flexUnits = totalFlexUnits;
        var totalViolation = 0;
        // 5b: Calculate the remaining free space
        flexColumnsLookup.frozenFields.forEach(function(field) {
            remainingFreeSpace -= flexColumnsLookup.all[field].computedWidth;
            flexUnits -= flexColumnsLookup.all[field].flex;
        });
        for(var i = 0; i < flexColumns.length; i += 1){
            var column = flexColumns[i];
            if (flexColumnsLookup.all[column.field] && flexColumnsLookup.all[column.field].frozen === true) {
                continue;
            }
            // 5c: Distribute remaining free space proportional to the flex factors
            var widthPerFlexUnit = remainingFreeSpace / flexUnits;
            var computedWidth = widthPerFlexUnit * column.flex;
            // 5d: Fix min/max violations
            if (computedWidth < column.minWidth) {
                totalViolation += column.minWidth - computedWidth;
                computedWidth = column.minWidth;
                violationsLookup.min[column.field] = true;
            } else if (computedWidth > column.maxWidth) {
                totalViolation += column.maxWidth - computedWidth;
                computedWidth = column.maxWidth;
                violationsLookup.max[column.field] = true;
            }
            flexColumnsLookup.all[column.field] = {
                frozen: false,
                computedWidth: computedWidth,
                flex: column.flex
            };
        }
        // 5e: Freeze over-flexed items
        if (totalViolation < 0) {
            // Freeze all the items with max violations
            Object.keys(violationsLookup.max).forEach(function(field) {
                flexColumnsLookup.freeze(field);
            });
        } else if (totalViolation > 0) {
            // Freeze all the items with min violations
            Object.keys(violationsLookup.min).forEach(function(field) {
                flexColumnsLookup.freeze(field);
            });
        } else {
            // Freeze all items
            flexColumns.forEach(function(param) {
                var field = param.field;
                flexColumnsLookup.freeze(field);
            });
        }
        // 5f: Return to the start of this loop
        loopOverFlexItems();
    }
    loopOverFlexItems();
    return flexColumnsLookup.all;
}
/**
 * Compute the `computedWidth` (ie: the width the column should have during rendering) based on the `width` / `flex` / `minWidth` / `maxWidth` properties of `GridColDef`.
 * The columns already have been merged with there `type` default values for `minWidth`, `maxWidth` and `width`, thus the `!` for those properties below.
 * TODO: Unit test this function in depth and only keep basic cases for the whole grid testing.
 * TODO: Improve the `GridColDef` typing to reflect the fact that `minWidth` / `maxWidth` and `width` can't be null after the merge with the `type` default values.
 */ export var hydrateColumnsWidth = function(rawState, dimensions) {
    var columnsLookup = {};
    var totalFlexUnits = 0;
    var widthAllocatedBeforeFlex = 0;
    var flexColumns = [];
    // For the non-flex columns, compute their width
    // For the flex columns, compute their minimum width and how much width must be allocated during the flex allocation
    rawState.orderedFields.forEach(function(columnField) {
        var column = rawState.lookup[columnField];
        var computedWidth = 0;
        var isFlex = false;
        if (rawState.columnVisibilityModel[columnField] !== false) {
            if (column.flex && column.flex > 0) {
                totalFlexUnits += column.flex;
                isFlex = true;
            } else {
                computedWidth = clamp(column.width || GRID_STRING_COL_DEF.width, column.minWidth || GRID_STRING_COL_DEF.minWidth, column.maxWidth || GRID_STRING_COL_DEF.maxWidth);
            }
            widthAllocatedBeforeFlex += computedWidth;
        }
        if (column.computedWidth !== computedWidth) {
            column = _extends({}, column, {
                computedWidth: computedWidth
            });
        }
        if (isFlex) {
            flexColumns.push(column);
        }
        columnsLookup[columnField] = column;
    });
    var availableWidth = dimensions === undefined ? 0 : dimensions.viewportOuterSize.width - (dimensions.hasScrollY ? dimensions.scrollbarSize : 0);
    var initialFreeSpace = Math.max(availableWidth - widthAllocatedBeforeFlex, 0);
    // Allocate the remaining space to the flex columns
    if (totalFlexUnits > 0 && availableWidth > 0) {
        var computedColumnWidths = computeFlexColumnsWidth({
            initialFreeSpace: initialFreeSpace,
            totalFlexUnits: totalFlexUnits,
            flexColumns: flexColumns
        });
        Object.keys(computedColumnWidths).forEach(function(field) {
            columnsLookup[field].computedWidth = computedColumnWidths[field].computedWidth;
        });
    }
    return _extends({}, rawState, {
        lookup: columnsLookup
    });
};
/**
 * Apply the order and the dimensions of the initial state.
 * The columns not registered in `orderedFields` will be placed after the imported columns.
 */ export var applyInitialState = function(columnsState, initialState) {
    var _loop = function(i1) {
        var field = columnsWithUpdatedDimensions[i1];
        var newColDef = _extends({}, newColumnLookup[field], {
            hasBeenResized: true
        });
        Object.entries(dimensions[field]).forEach(function(param) {
            var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
            newColDef[key] = value === -1 ? Infinity : value;
        });
        newColumnLookup[field] = newColDef;
    };
    if (!initialState) {
        return columnsState;
    }
    var _initialState_orderedFields = initialState.orderedFields, orderedFields = _initialState_orderedFields === void 0 ? [] : _initialState_orderedFields, _initialState_dimensions = initialState.dimensions, dimensions = _initialState_dimensions === void 0 ? {} : _initialState_dimensions;
    var columnsWithUpdatedDimensions = Object.keys(dimensions);
    if (columnsWithUpdatedDimensions.length === 0 && orderedFields.length === 0) {
        return columnsState;
    }
    var orderedFieldsLookup = {};
    var cleanOrderedFields = [];
    for(var i = 0; i < orderedFields.length; i += 1){
        var field = orderedFields[i];
        // Ignores the fields in the initialState that matches no field on the current column state
        if (columnsState.lookup[field]) {
            orderedFieldsLookup[field] = true;
            cleanOrderedFields.push(field);
        }
    }
    var newOrderedFields = cleanOrderedFields.length === 0 ? columnsState.orderedFields : _to_consumable_array(cleanOrderedFields).concat(_to_consumable_array(columnsState.orderedFields.filter(function(field) {
        return !orderedFieldsLookup[field];
    })));
    var newColumnLookup = _extends({}, columnsState.lookup);
    for(var i1 = 0; i1 < columnsWithUpdatedDimensions.length; i1 += 1)_loop(i1);
    var newColumnsState = _extends({}, columnsState, {
        orderedFields: newOrderedFields,
        lookup: newColumnLookup
    });
    return newColumnsState;
};
function getDefaultColTypeDef(type) {
    var colDef = COLUMN_TYPES[DEFAULT_GRID_COL_TYPE_KEY];
    if (type && COLUMN_TYPES[type]) {
        colDef = COLUMN_TYPES[type];
    }
    return colDef;
}
export var createColumnsState = function(param) {
    var apiRef = param.apiRef, columnsToUpsert = param.columnsToUpsert, initialState = param.initialState, _param_columnVisibilityModel = param.columnVisibilityModel, columnVisibilityModel = _param_columnVisibilityModel === void 0 ? gridColumnVisibilityModelSelector(apiRef) : _param_columnVisibilityModel, _param_keepOnlyColumnsToUpsert = param.keepOnlyColumnsToUpsert, keepOnlyColumnsToUpsert = _param_keepOnlyColumnsToUpsert === void 0 ? false : _param_keepOnlyColumnsToUpsert;
    var _apiRef_current_getRootDimensions, _apiRef_current;
    var isInsideStateInitializer = !apiRef.current.state.columns;
    var columnsState;
    if (isInsideStateInitializer) {
        columnsState = {
            orderedFields: [],
            lookup: {},
            columnVisibilityModel: columnVisibilityModel
        };
    } else {
        var currentState = gridColumnsStateSelector(apiRef.current.state);
        columnsState = {
            orderedFields: keepOnlyColumnsToUpsert ? [] : _to_consumable_array(currentState.orderedFields),
            lookup: _extends({}, currentState.lookup),
            // Will be cleaned later if keepOnlyColumnsToUpsert=true
            columnVisibilityModel: columnVisibilityModel
        };
    }
    var columnsToKeep = {};
    if (keepOnlyColumnsToUpsert && !isInsideStateInitializer) {
        columnsToKeep = Object.keys(columnsState.lookup).reduce(function(acc, key) {
            return _extends({}, acc, _define_property({}, key, false));
        }, {});
    }
    var columnsToUpsertLookup = {};
    columnsToUpsert.forEach(function(newColumn) {
        var field = newColumn.field;
        columnsToUpsertLookup[field] = true;
        columnsToKeep[field] = true;
        var existingState = columnsState.lookup[field];
        if (existingState == null) {
            existingState = _extends({}, getDefaultColTypeDef(newColumn.type), {
                field: field,
                hasBeenResized: false
            });
            columnsState.orderedFields.push(field);
        } else if (keepOnlyColumnsToUpsert) {
            columnsState.orderedFields.push(field);
        }
        // If the column type has changed - merge the existing state with the default column type definition
        if (existingState && existingState.type !== newColumn.type) {
            existingState = _extends({}, getDefaultColTypeDef(newColumn.type), {
                field: field
            });
        }
        var hasBeenResized = existingState.hasBeenResized;
        COLUMNS_DIMENSION_PROPERTIES.forEach(function(key) {
            if (newColumn[key] !== undefined) {
                hasBeenResized = true;
                if (newColumn[key] === -1) {
                    newColumn[key] = Infinity;
                }
            }
        });
        columnsState.lookup[field] = resolveProps(existingState, _extends({}, newColumn, {
            hasBeenResized: hasBeenResized
        }));
    });
    if (keepOnlyColumnsToUpsert && !isInsideStateInitializer) {
        Object.keys(columnsState.lookup).forEach(function(field) {
            if (!columnsToKeep[field]) {
                delete columnsState.lookup[field];
            }
        });
    }
    var columnsStateWithPreProcessing = apiRef.current.unstable_applyPipeProcessors('hydrateColumns', columnsState);
    var columnsStateWithPortableColumns = applyInitialState(columnsStateWithPreProcessing, initialState);
    var _apiRef_current_getRootDimensions1;
    return hydrateColumnsWidth(columnsStateWithPortableColumns, (_apiRef_current_getRootDimensions1 = (_apiRef_current_getRootDimensions = (_apiRef_current = apiRef.current).getRootDimensions) === null || _apiRef_current_getRootDimensions === void 0 ? void 0 : _apiRef_current_getRootDimensions.call(_apiRef_current)) !== null && _apiRef_current_getRootDimensions1 !== void 0 ? _apiRef_current_getRootDimensions1 : undefined);
};
export function getFirstNonSpannedColumnToRender(param) {
    var firstColumnToRender = param.firstColumnToRender, apiRef = param.apiRef, firstRowToRender = param.firstRowToRender, lastRowToRender = param.lastRowToRender, visibleRows = param.visibleRows;
    var firstNonSpannedColumnToRender = firstColumnToRender;
    for(var i = firstRowToRender; i < lastRowToRender; i += 1){
        var row = visibleRows[i];
        if (row) {
            var rowId = visibleRows[i].id;
            var cellColSpanInfo = apiRef.current.unstable_getCellColSpanInfo(rowId, firstColumnToRender);
            if (cellColSpanInfo && cellColSpanInfo.spannedByColSpan) {
                firstNonSpannedColumnToRender = cellColSpanInfo.leftVisibleCellIndex;
            }
        }
    }
    return firstNonSpannedColumnToRender;
}
export function getTotalHeaderHeight(apiRef, props) {
    if (props.unstable_listView) {
        return 0;
    }
    var densityFactor = gridDensityFactorSelector(apiRef);
    var maxDepth = gridColumnGroupsHeaderMaxDepthSelector(apiRef);
    var isHeaderFilteringEnabled = gridHeaderFilteringEnabledSelector(apiRef);
    var columnHeadersHeight = Math.floor(props.columnHeaderHeight * densityFactor);
    var _props_columnGroupHeaderHeight;
    var columnGroupHeadersHeight = Math.floor(((_props_columnGroupHeaderHeight = props.columnGroupHeaderHeight) !== null && _props_columnGroupHeaderHeight !== void 0 ? _props_columnGroupHeaderHeight : props.columnHeaderHeight) * densityFactor);
    var _props_headerFilterHeight;
    var filterHeadersHeight = isHeaderFilteringEnabled ? Math.floor(((_props_headerFilterHeight = props.headerFilterHeight) !== null && _props_headerFilterHeight !== void 0 ? _props_headerFilterHeight : props.columnHeaderHeight) * densityFactor) : 0;
    return columnHeadersHeight + columnGroupHeadersHeight * maxDepth + filterHeadersHeight;
}
